import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export type TClosingProtectionLetterGenerationType = 'borrower' | 'buyer' | 'lender' | 'seller';

export const generateClosingProtectionLetterAsync = async (
  orderId: string,
  cplType: TClosingProtectionLetterGenerationType
): Promise<boolean> => {
  const cplUrl = cplType !== 'lender' ? `${cplType}_` : '';
  return APIFactory(baseUrlService.ApiLocation)
    .post(`/documents/v5/enqueue/${orderId}/${cplUrl}closing_protection_letter`)
    .then((response) => response.status < 300)
    .catch(axiosErrorHandler);
};
